//TODO - fix lint issue
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars */
import { AuthService, LoadingService } from '@accesso/adk-portal-shared';
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { Observable, of } from 'rxjs';
import { UserGroups } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class AppPermissionGuard {
  private router = inject(Router);
  private authService = inject(AuthService);
  private loadingService = inject(LoadingService);


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (this.authService.isLoggedIn) {
      if (this.authService.user.idToken) {
        const user: any = jwtDecode(this.authService.user.idToken);
        const userGroups = user?.['cognito:groups'] as string[] | undefined;
        const isAdmin = userGroups?.some(
          (group) => group === UserGroups.CLIENT_ADMIN || group === UserGroups.SUPER_ADMIN || group === UserGroups.OWNER || group === UserGroups.PRODUCT_ADMIN
        );
        if (isAdmin) {
          return of(true);
        }
      }
    }
    this.loadingService.loadingOff();
    this.router.navigate(['/access-denied']);
    return of(false);
  }
}
